import React from 'react'
import _ from 'lodash'
import moment from 'moment'

import {DatePicker} from 'antd'
const {RangePicker} = DatePicker

export const DateTimeRange = ({update, to, from}) => {
   const fromTS = from ? moment(from) : undefined,
      toTS = from ? moment(to) : undefined

   return (
      <RangePicker
         value={[fromTS, toTS]}
         showTime={{hideDisabledOptions: true}}
         format="YYYY-MM-DD HH:mm:ss"
         placeholder={['Start Time', 'End Time']}
         onOk={val => {
            update('date.from', val[0].toISOString(), true)
            update('date.to', val[1].toISOString(), true)
         }}
         style={{width: '100%'}}
      />
   )
}

DateTimeRange.propTypes = {
   update: React.PropTypes.func.isRequired,
   to:     React.PropTypes.string,
   from:   React.PropTypes.string
}



// WEBPACK FOOTER //
// lib/bundle/dashboard/query/DateTimeRange.jsx